import React from "react";
import { PersonData } from "@/entities/people/types";
import PersonCard from "./PersonCard";
import { map } from "lodash";

interface PeopleCardsGridProps {
  people: PersonData[];
  getReportsToPersonName: (personId: string | null | undefined) => string;
}

const PeopleCardsGrid: React.FC<PeopleCardsGridProps> = ({
  people,
  getReportsToPersonName
}) => {
  return (
    <div className="grid grid-cols-3 gap-5 max-h-[50rem] overflow-y-auto px-4">
      {map(people, (person) => (
        <PersonCard
          key={person.id}
          person={person}
          getReportsToPersonName={getReportsToPersonName}
        />
      ))}
    </div>
  );
};

export default PeopleCardsGrid;
